var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.206v15.206H0z",
    fill: "#f25022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.794 0H32v15.206H16.794z",
    fill: "#7fba00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.794h15.206V32H0z",
    fill: "#00a4ef"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.794 16.794H32V32H16.794z",
    fill: "#ffb900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrosoft);
export default __webpack_public_path__ + "static/1768397567/media/icon-microsoft.45958f98a37d115aea97c26b60a6abc5.svg";
export { ForwardRef as ReactComponent };